<template>
    <Modal v-model="show"
        title="总监账号信息"
        :width="60">
        <Spin v-if="$globalSpin"
            size="large"
            fix></Spin>
        <Form ref="userForm"
            :model="userForm"
            :rules="ruleValidate"
            label-position="top"
            class="small-form">

            <Row :gutter="16">
                <Col span="6">
                <FormItem label="登录帐号"
                    prop="userName">
                    <Input v-model="userForm.userName" placeholder="请以J开头"
                        :readonly="formEditMode===FORM_EDIT_MODE_MODIFY"></Input>
                </FormItem>
                </Col>
                <Col span="6">
                <FormItem label="角色"
                    prop="roleUuid">
                    <Select placeholder="请选择角色" v-model="userForm.roleUuid" filterable clearable >
						<Option v-for="(item,index) in roleIdList" :value="item.roleUuid" :key="item.roleUuid">{{ item.name }}</Option>
					</Select>
                </FormItem>
                </Col>
				<Col span="6">
				<FormItem label="姓名" prop="userPersonName">
                    <Input placeholder="请输入姓名" v-model="userForm.userPersonName"></Input>
				</FormItem>
				</Col>
                <Col span="6">
                <FormItem label="手机" prop="userPhone">
                    <Input placeholder="请输入手机号" v-model="userForm.userPhone"></Input>
                </FormItem>
                </Col>
            </Row>

            <Row :gutter="16">
                <Col span="6">
                <FormItem label="苗场" prop="department">
                    <Select
                        v-model="userForm.seedFarmUuids"
                        clearable
                        filterable
                        multiple
                    >
                        <Option
                            v-for="item in seedFarmList"
                            :key="item.seedFarmUuid"
                            :value="item.seedFarmUuid"
                            >{{ item.seedFarmCode }}-{{ item.seedFarmName }}</Option>
                    </Select>
                </FormItem>
                </Col>
                <Col span="6">
                <FormItem label="状态">
                    <RadioGroup v-model="userForm.userStatus"
                        type="button">
                        <Radio v-for="item in approvalSource"
                            :key="item.val"
                            :label="item.val">{{ item.label }}
                        </Radio>
                    </RadioGroup>
                </FormItem>
                </Col>
            </Row>

            <Row :gutter="16">
                <Col v-if="formEditMode === FORM_EDIT_MODE_CREATE"
                    span="6">
                <FormItem label="密码">
                    <Input placeholder="请输入密码" v-model="password"
                        type="password"></Input>
                </FormItem>
                </Col>
                <Col v-if="formEditMode === FORM_EDIT_MODE_CREATE"
                    span="6">
                <FormItem label="密码确认">
                    <Input placeholder="请输入密码确认" v-model="passwordConfirm"
                        type="password"></Input>
                </FormItem>
                </Col>
            </Row>
        </Form>
        <div slot="footer">
            <Button type="primary"
                @click="onSave">确认</Button>
            <Button type="error"
                @click="onCancel">取消</Button>
        </div>
    </Modal>
</template>

<script>
import search from "@/libs/search";
import { STATUS_ACTIVE, STATUS_INACTIVE, statusFormat } from '@/libs/baseModelFormat';
import { FORM_EDIT_MODE_CREATE, FORM_EDIT_MODE_MODIFY } from '@/view/mixins/form-edit-mode';

import { getRoleList, inspectorUserSave, getInspectorUserDetail, getUserPersonNameList } from '@/api/modules/account-management/inspector-user-management';
import { getSeedFarmList } from '@/api/modules/system-management/seedFarm-management';
export default {
    name: 'InspectorUserEdit',
    data() {
        return {
            show: false,
            accountUuid: '',
            FORM_EDIT_MODE_CREATE,
            FORM_EDIT_MODE_MODIFY,
            formEditMode: FORM_EDIT_MODE_CREATE,
            pageLoading: false,
            userForm: {
                userUuid: '',
                userName: '',
                userPersonName: '',
                userPhone: '',
                userType: 'J',
                roleUuid: '',
                userStatus: STATUS_ACTIVE,
                departmentUuid: '',
                seedFarmUuids: []
            },
            ruleValidate: {
                userName: [
                    {
                        trigger: 'blur',
                        required: true,
                        validator: (rule, value, callback) => {
                            if (value) {
                                if (value.length >= 3 && value.length <= 20) {
                                    let firstVal=value.charAt(0);
                                    if(firstVal!='J'){
                                        callback(new Error('账号开头必须为J'));
                                    }
                                    else{
                                        callback();
                                    }
                                }
                                else {
                                    callback(new Error('账号长度在3-20个字符之间'));
                                }
                            }
                            else {
                                callback(new Error(' '));
                            }
                        }
                    }
                ]
            },
            password: '',
            passwordConfirm: '',
            approvalSource: [],
            roleIdList: [],
            seedFarmList: []
        };
    },
    mounted() {
        // 可以在这里进行初始化操作
    },
    methods: {
        // 显示模态框
        showModal(accountUuid) {
            if (accountUuid === '') {
                this.accountUuid = '';
                this.formEditMode = FORM_EDIT_MODE_CREATE;
            }
            else {
                this.formEditMode = FORM_EDIT_MODE_MODIFY;
                this.accountUuid = accountUuid;
            }
            this.init();
            this.show = true;
        },
        // 初始化数据
        init() {
            this.initDataSources();
            this.loadRoleList();
            this.loadSeedFarmList();
            this.loadUserDetail();
        },

        // 初始化数据源
        initDataSources() {
            this.approvalSource = [
                { val: STATUS_ACTIVE, label: statusFormat(STATUS_ACTIVE) },
                { val: STATUS_INACTIVE, label: statusFormat(STATUS_INACTIVE) }
            ];
            this.userForm.userUuid = '';
            this.userForm.userName = '';
            this.userForm.userPersonName = '';
            this.userForm.userPhone = '';
            this.userForm.userStatus = STATUS_ACTIVE;
            this.userForm.userType = 'J';
            this.userForm.roleUuid = '';
            this.userForm.departmentUuid = '';
            this.userForm.seedFarmUuids = [];
        },

        // 加载角色列表
        loadRoleList() {
            getRoleList({ type: '总监' }).then(res => {
                if (res.code === 0) {
                    if (res.data.records != null) {
                        this.roleIdList = res.data.records;
                    }
                }
            });
        },

        loadSeedFarmList(){
            let tempSearch = search.getSearchParams({
                closeAllConditions: true
            });
            getSeedFarmList({}).then(res => {
                if (res.code === 0) {
                    if (res.data.records != null) {
                        this.seedFarmList = res.data.records;
                    }
                }
            });
        },

        // 加载用户详细信息
        loadUserDetail() {
            if (this.accountUuid !== '') {
                this.formEditMode = FORM_EDIT_MODE_MODIFY;
                getInspectorUserDetail({ userUuid: this.accountUuid }).then(res => {
                    if (res.code === 0) {
                        const info = res.data.userModel;
                        this.userForm.userUuid = info.userUuid;
                        this.userForm.userName = info.userName;
                        this.userForm.userPersonName = info.userPersonName;
                        this.userForm.userPhone = info.userPhone;
                        this.userForm.userStatus = info.userStatus;
                        this.userForm.userType = info.userType;
                        this.userForm.roleUuid = info.roleUuid;
                        this.userForm.departmentUuid = info.departmentUuid;
                        this.userForm.seedFarmUuids = info.seedFarmUuids;
                    }
                }).catch(() => {
                    // 错误处理
                });
            }
            else {
                this.$refs.userForm.resetFields();
            }
        },
        // 保存用户数据
        onSave() {
            console.log('onSave', this.userForm);
            this.$refs.userForm.validate(valid => {
                if (!valid) {
                    this.$Message.error('表单验证失败!');
                    return;
                }

                const data = Object.assign({ formEditMode: this.formEditMode }, this.userForm);
                if (this.formEditMode === FORM_EDIT_MODE_CREATE) {
                    data.password = this.password;
                    data.passwordConfirm = this.passwordConfirm;
                }

                this.saveUserData(data);
            });
        },

        // 保存数据到服务器
        saveUserData(data) {
            this.$showGlobalSpin();
            inspectorUserSave(data).then(res => {
                this.$hideGlobalSpin();
                if (res.code === 0) {
                    this.$Modal.success({
                        title: '保存成功',
                        onOk: () => {
                            this.show = false;
                            this.$refs.userForm.resetFields();
                            this.$parent.getInspectorUserTableRecords();
                        }
                    });
                }
            });
        },

        // 取消操作
        onCancel() {
            this.show = false;
            this.$refs.userForm.resetFields();
        }
    }
};
</script>

<style scoped>
</style>
